<template>
    <div class="modal fade" id="ConfirmDuplicateModal" tabindex="-1" role="dialog" aria-labelledby="ConfirmDuplicateModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title" id="ConfirmDuplicateModalLabel">ยืนยันการทำซ้ำ!!</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label for="post_tag_name">ชื่อเมนูใหม่</label>
                    <input type="text" class="form-control" id="post_tag_name" v-model="newMenuName">                                            
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" v-bind:disabled="newMenuNameIsBlank()" class="btn btn-info" data-dismiss="modal" @click="ConFirmDuplicateClick()">มั่นใจมาก ทำซ้ำเลย</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">ไม่ดีกว่า</button>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
export default { 
        props:{
            // newMenuName:'',
        },
        name:'confirmDuplicateModal',
        data() {
            return {
                //paginate_data:{}    
                newMenuName:''
            }
        },
        mounted() {
            //console.log('Component mounted.')            
            //console.log(0,this.paginate_data);
        },
        created(){
            //console.log(this.paginate_data);
            //console.log(1,this.paginate_data);
        },
        methods:{          
            ConFirmDuplicateClick(){                
                this.$emit('ConFirmDuplicateClick', this.newMenuName);
            },
            newMenuNameIsBlank(){                
                return this.newMenuName==='';
            }
        },        
    
}
</script>